<template>
   <div class="sd_login_page">
      <div class="form_box">
         <div class="title">
            <h5>登录</h5>
         </div>
         <div class="input_box">
            <h5>欢迎回来</h5>
            <el-form :model="form" v-show="loginType == 1" :rules="rules" ref="ruleForm" class="demo-ruleForm">
               <el-form-item prop="username">
                  <el-input v-model="form.username" placeholder="用户名"></el-input>
               </el-form-item>
               <el-form-item prop="password">
                  <el-input v-model="form.password" placeholder="密码" show-password></el-input>
               </el-form-item>
              <!-- <el-form-item prop="code">
                  <el-row>
                     <el-col :span="15">
                        <el-input v-model="form.code" placeholder="验证码"></el-input>
                     </el-col>
                     <el-col :span="1">

                     </el-col>
                     <el-col :span="8">
                        <img :src="codeimg" @click="getcodeImg" alt="">
                     </el-col>
                  </el-row>
               </el-form-item>
-->
               <el-form-item>
                  <br>
                  <el-button type="primary" class="login_btn" @click="submitForm('ruleForm')">登录</el-button>
               </el-form-item>
               <el-form-item>
                  <div class="links">
                     <a href="javascript:;" @click="loginType = 2">手机号登录</a>
                     <router-link to="/password">忘记密码？</router-link>
                  </div>
               </el-form-item>
            </el-form>
            <el-form :model="form2" v-show="loginType == 2" :rules="rules2" ref="ruleForm2" class="demo-ruleForm">
               <el-form-item prop="username">
                  <el-input v-model="form2.username" placeholder="手机号"></el-input>
               </el-form-item>
               <el-form-item prop="code">
                  <el-row>
                     <el-col :span="15">
                        <el-input v-model="form2.code" placeholder="验证码"></el-input>
                     </el-col>
                     <el-col :span="1">

                     </el-col>
                     <el-col :span="8">
                        <el-button type="primary" v-if="sendcode" class="getcode" @click="codePost">获取验证码</el-button>
                        <el-button  type="primary" class="getcode active" v-else>{{count}} s</el-button>
                     </el-col>
                  </el-row>
               </el-form-item>

               <el-form-item>
                  <br>
                  <el-button type="primary" class="login_btn" @click="submitForm2('ruleForm2')">登录</el-button>
               </el-form-item>
               <el-form-item>
                  <div class="links">
                     <a href="javascript:;" @click="loginType = 1">账号登录</a>
                     <router-link to="/password">忘记密码？</router-link>
                  </div>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <imgcode @backfun="backCode" :status="imgCodeStatus" v-if="imgCodeStatus"/>
   </div>
</template>
<script>
   import imgcode from "@/components/dialog/imgcode_dialog.vue"
   export default {
      name: 'sd_login_page',
      components: {
         imgcode
      },

      
      data() {
         var validatorPhone = function (rule, value, callback) {
            if (value === '') {
               callback(new Error('手机号不能为空'))
            } else if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式错误'))
            } else {
               callback();
            }
         };
         return {
            loginType:1,
            codeimg: '',
            form: {
               "appCode": "6FNFVn",
               "code": "",
               "password": "",
               "username": "",
               "uuid": ""
            },
            rules: {
               username: [{
                  required: true,
                  message: '请输入账号',
                  trigger: 'blur'
               }, ],
               password: [{
                  required: true,
                  message: '请输入密码',
                  trigger: 'blur'
               }, ],
               // code: [{
               //    required: true,
               //    message: '请输入验证码',
               //    trigger: 'blur'
               // }, ],
            },
            imgCodeStatus:false,

            form2: {
               "appCode": "6FNFVn",
               "code": "",
               "username": "",
            },
            rules2: {
               username: [  { validator: validatorPhone, trigger: 'blur' } ],
               code: [{
                  required: true,
                  message: '请输入手机验证码',
                  trigger: 'blur'
               }, ],
            },
            //发送验证码
            sendcode:true,
            count: 60,
            timer: null,
         };
      },
      created() {

      },
      activated() {
         //只刷新数据，不改变整体的缓存

      },
      methods: {
         submitForm(formName) {
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  this.imgCodeStatus = true;
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
         login() {
            var _this = this;
            _this.$api.login({
               ...this.form
            }).then(res => {
               if (res.code == 200) {
                  this.$message({
                     message: '登录成功！',
                     type:'success',
                  });
                  _this.$setCookie('sd_token', res.token);
                  _this.getUserInfo();
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         getUserInfo(){
            var _this = this;
            _this.$api.getUser( ).then(res => {
               if (res.code == 200) {
                  localStorage.setItem('sd_userInfo', JSON.stringify(res.data));
                  var path = localStorage.getItem('login_backurl');
                  if(path){
                       this.$router.replace(path);
                    }else{
                       window.location.href='/web/';
                    }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         getcodeImg(){
            var _this = this;
            _this.$api.captchaImage().then(res => {
               if (res.code == 200) {

                  this.codeimg = "data:image/gif;base64," + res.img;
                  this.form.uuid = res.uuid;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         checklogin() {
            var _this = this;
            _this.$api.checklogin({}).then(res => {
               if (res.code == 200) {

               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         backCode(box){
            //this.form.code = code;
            this.form.code= box.code;
            this.form.uuid = box.uuid;
            this.imgCodeStatus = false;
            this.login();
         },


         //发送验证码
         codePost() {
            var _this = this;
            var reg_phone = /^1\d{10}$/;
            if(!reg_phone.test(this.form2.username)){
               _this.$message.error('请填写正确的手机号码！');
               return false;
            }
            _this.$api.sendCode({
               phone: this.form2.username
            }).then(res => {
               if (res.code == 200) {
                  this.$message({
                     message: '发送成功！',
                     type: 'success'
                  });
                  this.setTime();
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         setTime(){
            const TIME_COUNT = 60;
            if (!this.timer) {
               this.count = TIME_COUNT;
               this.sendcode = false;
               this.timer = setInterval(() => {
                  if (this.count > 1 && this.count <= TIME_COUNT) {
                     this.count--;
                  } else {
                     this.sendcode = true;
                     clearInterval(this.timer);
                     this.timer = null;
                  }
               }, 1000)
            }
         },
         loginBySms() {
            var _this = this;
            _this.$api.loginBySms({
               ...this.form2
            }).then(res => {
               if (res.code == 200) {
                  _this.$setCookie('sd_token', res.token);
                  _this.getUserInfo();
               } else {
                  _this.getcodeImg();
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         submitForm2(formName) {
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  this.loginBySms();
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
      }
   }
</script>
<style lang="less">

</style>
